const ALERT_SEVERITY_TYPE = {
  WARNING: 'warning'
}

export { ALERT_SEVERITY_TYPE }
